import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  Inject,
  OnInit,
  Renderer2,
  ViewChild
} from "@angular/core";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { TuiDialogContext } from "@taiga-ui/core";
import { POLYMORPHEUS_CONTEXT } from "@tinkoff/ng-polymorpheus";
import { NgxSpinnerService } from "ngx-spinner";
import { ApiService } from "src/app/core/services/shared/api.service";
import { GlobalVarService } from "src/app/core/services/shared/global-var.service";
import { NotificationService } from "src/app/core/services/shared/notification.service";

@Component({
  selector: "app-vfr-upload",
  templateUrl: "./vfr-upload.component.html",
  styleUrls: ["./vfr-upload.component.scss"],
})
export class VfrUploadComponent implements OnInit {
  zoom = 1;
  zoomValue = 100; // Initial zoom value in percentage
  originalZoomValue = 100;
  viewImgPdfArray: any[] = [];
  selectedFile: File | null = null;
  pdfSrc = "";
  ispdf = false;
  isimage = false;
  previewUrl: SafeResourceUrl | null = null;
  acceptFileType = "application/pdf,image/*";
  pdfUrl: any;
  isUploadedFile: boolean = false;
  universityVfrFileUpdated = [];
  isZoomInDisable: boolean = false;
  isZoomOutDisable: boolean = true;
  documentTypeId: string;
  IsLoadData: boolean = false;
  fileIds = [];
  FileType: any;
  srcList = [];
  uploadFileType = {};
  filesArray = [];
  errorMessage: string = "";
  zoomInOutClientWith: number = 0;
  // zoomInOutClientWith = new BehaviorSubject<number>(0);
  acceptedFile = {};
  today: string = "";
  yearsArr = [];
  dragAreaClass: string | undefined;
  fileUploadArray = [];
  ocrResponseList: any;
  ipedsId: string = "";
  index: string = "";
  totalAmount = {
    totalCoa: 0,
    totalGrantsSCholarship: 0,
    totalLoan: 0,
    totalAdditionalost: 0,
    outOfPocket: 0,
    coaCorrect: true,
    grantCorrect: true,
    coaValidated: false,
    grantValidated: false,
  };
  @ViewChild("pdfCanvas", { static: false })
  pdfCanvas: ElementRef<HTMLCanvasElement>;
  closebtnonapicall: boolean = false;
  responsedocumentype: any;
  onFileChange(event: any) {
    if (event.target.files && event.target.files.length > 0) {
      const file: File = event.target.files[0];
      this.FileType = file.type.split("/");
      this.uploadFileType[0] = file.type;
      if (this.checkFileType(file.type)) {
        this.IsLoadData = true;
        if (this.FileType[1] == "pdf") {
          this.documentTypeId = "pdf";
          this.ispdf = true;
          this.isimage = false;
          this.previewFile(file);
        }
        if (
          this.FileType[1] == "png" ||
          this.FileType[1] == "jpg" ||
          this.FileType[1] == "jpeg"
        ) {
          this.isimage = true;
          this.documentTypeId = this.FileType[1];

          this.ispdf = false;
          this.previewFile(file);
        }
      } else {
        this.errorMessage =
          "The specified file (" +
          this.uploadFileType[0] +
          ") could not be uploaded.(PDF, JPG, JPEG and PNG files are supported)";
      }
    }
  }
  previewFile(file: File) {
    if (typeof FileReader !== "undefined") {
      this.viewImgPdfArray = [];
      let reader = new FileReader();
      reader.onload = (e: any) => {
        const unsafeUrl = reader.result as string;
        if (this.isimage) {
          this.previewUrl = this.sanitizer.bypassSecurityTrustUrl(unsafeUrl);

          let obj = {
            URL: this.sanitizer.bypassSecurityTrustUrl(unsafeUrl),
          };
          this.viewImgPdfArray.push(obj);
          this.cdref.detectChanges();
          this.uploadFile(file);
        } else {
          this.pdfSrc = e.target.result;
          let obj = {
            URL: this.pdfSrc,
          };
          this.viewImgPdfArray.push(obj);
          this.cdref.detectChanges();
          this.uploadFile(file);
        }
      };
      if (this.isimage) {
        reader.readAsDataURL(file);
      } else {
        reader.readAsArrayBuffer(file);
      }
    }
  }
  universityData: any;

  constructor(
    public apiService: ApiService,
    private sanitizer: DomSanitizer,
    private cdref: ChangeDetectorRef,
    private spinnerService: NgxSpinnerService,
    private notificatioService: NotificationService,
    private renderer: Renderer2,
    private globalvar: GlobalVarService,
    private el: ElementRef,
    @Inject(POLYMORPHEUS_CONTEXT)
    private readonly context: TuiDialogContext<any, any>
  ) {
    const dialog = document.querySelector("tui-dialog");
    dialog.classList.add("vfr");
    this.universityData = context.data;
    this.ocrResponseList = context.data.ocrResponseListTotal;
    this.index = context.data.index;
    this.universityVfrFileUpdated = [];
    this.universityVfrFileUpdated.push(this.ocrResponseList[this.index]);
    this.ipedsId = context.data.ipedsId;
    this.initializeFileData(this.index, this.ipedsId, this.ocrResponseList);
  }

  changeAnalysisTotal() {
    this.totalAmount.outOfPocket =
      this.totalAmount.totalCoa - this.totalAmount.totalGrantsSCholarship > 0
        ? this.totalAmount.totalCoa - this.totalAmount.totalGrantsSCholarship
        : 0;
  }

  ngOnInit(): void {
    this.dragAreaClass = "";
    let year = new Date().getFullYear();

    while (year >= 2002) {
      this.yearsArr.push(year);
      year--;
    }

    this.today =
      new Date().getFullYear() +
      "-" +
      (new Date().getMonth() < 10
        ? "0" + new Date().getMonth()
        : new Date().getMonth()) +
      "-" +
      (new Date().getDate() < 10
        ? "0" + new Date().getDate()
        : new Date().getDate());
  }

  @HostListener("dragover", ["$event"]) onDragOver(event: any) {
    this.dragAreaClass = "droparea";
    event.preventDefault();
  }
  @HostListener("dragenter", ["$event"]) onDragEnter(event: any) {
    this.dragAreaClass = "droparea";
    event.preventDefault();
  }
  @HostListener("dragend", ["$event"]) onDragEnd(event: any) {
    this.dragAreaClass = "droparea";
    event.preventDefault();
  }
  @HostListener("dragleave", ["$event"]) onDragLeave(event: any) {
    this.dragAreaClass = "";
    event.preventDefault();
  }
  @HostListener("drop", ["$event"]) onDrop(event: any) {
    this.dragAreaClass = "";
    event.preventDefault();
    event.stopPropagation();
    if (event.dataTransfer.files) {
      let files: File = event.dataTransfer.files[0];
      let file: FileList = event.dataTransfer.files;
      if(file.length>1){
        this.errorMessage = "Only one file can be uploaded at a time";
        this.viewImgPdfArray = [];
        return
      }else{
        this.FileType = files.type.split("/");
        this.uploadFileType[0] = files.type;
        if (this.checkFileType(files.type)) {
          this.IsLoadData = true;
          if (this.FileType[1] == "pdf") {
            this.ispdf = true;
            this.isimage = false;
            this.previewFile(files);
          }
          if (
            this.FileType[1] == "png" ||
            this.FileType[1] == "jpg" ||
            this.FileType[1] == "jpeg"
          ) {
            this.ispdf = false;
            this.previewFile(files);
          }
        } else {
          this.errorMessage =
            "The specified file (" +
            this.uploadFileType[0] +
            ") could not be uploaded.(PDF, JPG, JPEG and PNG files are supported)";
        }
      }
      
    }
  }

  saveFiles(files: FileList) {
    if (files.length > 1) {
      this.errorMessage = "Only one file can be uploaded at a time";
      this.uploadFileType = [];
    } else {
      // this.error = "";
      //  this.updloadFile(files[0]);
    }
  }

  close() {
    let data = {
      index: this.index,
      ipedsId: this.ipedsId,
      vfrFileUpdated: this.universityVfrFileUpdated,
      isUploadedFile: this.isUploadedFile,
      ocrResponseList: this.ocrResponseList,
    };
    this.context.completeWith(data);
    // const dialog = document.querySelector("tui-dialog");
    // dialog.classList.remove("vfr");
  }

  resetFile() {
    this.errorMessage = "";
    this.viewImgPdfArray = [];
    // this.fileUploadArray[0].fileIds = [];
    this.universityVfrFileUpdated = [];
    this.isUploadedFile = true;
    this.ocrResponseList[this.index] = [];
  }
  initializeFileData(index: string, ipedsId: string, ocrResponseList: any) {
    this.fileUploadArray = [];
    this.fileUploadArray.push({
      dateOfAward: this.getToday(new Date()),
      award: "Annual",
      universityName: "",
      enrollmentYear: new Date().getFullYear(),
      documentFileFormat: "PDF",
      fileIds: ocrResponseList[index]
        ? ocrResponseList[index].analylizedFiles
        : [],
      files: [],
    });
    this.totalAmount = {
      totalCoa: 0,
      totalGrantsSCholarship: 0,
      totalLoan: 0,
      totalAdditionalost: 0,
      outOfPocket: 0,
      coaCorrect: true,
      grantCorrect: true,
      coaValidated: false,
      grantValidated: false,
    };

    const currentOcrData = ocrResponseList[index];
    if (currentOcrData) {
      const totalCoaIndex = currentOcrData.detectedValues.findIndex((elem) => {
        return elem.fieldId == 501;
      });
      const totalAidIndex = currentOcrData.detectedValues.findIndex((elem) => {
        return elem.fieldId == 601;
      });
      if (totalCoaIndex > -1) {
        this.totalAmount.totalCoa =
          currentOcrData.detectedValues[totalCoaIndex].value;
        this.totalAmount.totalGrantsSCholarship =
          currentOcrData.detectedValues[totalAidIndex].value;
      } else {
        currentOcrData.detectedValues.forEach((elem) => {
          if (elem.mapWith == 1) {
            this.totalAmount.totalCoa += Number(elem.value);
          } else if (elem.mapWith == 2) {
            this.totalAmount.totalGrantsSCholarship += Number(elem.value);
          } else if (elem.mapWith == 3) {
            this.totalAmount.totalLoan += Number(elem.value);
          } else if (elem.mapWith == 2) {
            this.totalAmount.totalAdditionalost += Number(elem.value);
          }
        });
      }
      this.totalAmount.outOfPocket =
        this.totalAmount.totalCoa - this.totalAmount.totalGrantsSCholarship > 0
          ? this.totalAmount.totalCoa - this.totalAmount.totalGrantsSCholarship
          : 0;
    } else {
      this.totalAmount = {
        totalCoa: 0,
        totalAdditionalost: 0,
        totalGrantsSCholarship: 0,
        totalLoan: 0,
        outOfPocket: 0,
        coaCorrect: true,
        grantCorrect: true,
        coaValidated: false,
        grantValidated: false,
      };
    }

    // if (this.fileUploadArray[0].fileIds.length > 0) {

    //   let srcList =[];
    if (ocrResponseList[index]?.documentTypeId == "pdf") {
      this.responsedocumentype = ocrResponseList[index]?.documentTypeId;
      this.viewImgPdfArray = [];
      this.ispdf = true;
      let Obj = {
        URL:
          this.getPath() +
          "fileStorage/download/" +
          ocrResponseList[index]?.uploadedFileId,
        Addcss: true,
      };
      this.viewImgPdfArray.push(Obj);
    } else {
      this.viewImgPdfArray = [];
      this.isimage = true;
      this.fileUploadArray[0].fileIds.forEach((id) => {
        let Obj = {
          URL: this.getPath() + "fileStorage/download/" + id,
        };
        this.viewImgPdfArray.push(Obj);
      });
    }
  }

  getPath() {
    return this.apiService.getHost();
  }

  checkFileType(type) {
    if (this.acceptFileType.indexOf(type) > -1 || type.indexOf("image") > -1)
      return true;
    else return false;
  }

  // updloadFile(file: any) {
  //   if (file && file.type) {
  //     this.uploadFileType[0] = file.type;
  //     if (this.checkFileType(file.type)) {
  //       this.IsLoadData = true;
  //       this.apiService.uploadWithProgressFile(file, (resp) => {
  //         console.log(this.pdfUrl, "pdfUrl", resp);
  //         if (!resp || resp.error) {
  //           // this.acceptedFile[this.index] = "";
  //           // this.changeFileType(this.acceptedFile[0]);
  //           if (!resp || resp.status == 0) {
  //             this.errorMessage =
  //               "Something went wrong while uploading award letter. ";
  //           } else {
  //             this.errorMessage = resp.message;
  //           }
  //         } else {
  //           this.errorMessage = "";
  //           file.resp = resp;
  //           this.pdfUrl = file.resp.id;
  //           // this.filesArray.push(file);
  //           // this.submitFile();
  //         }
  //       });
  //     } else {
  //       this.errorMessage =
  //         "The specified file (" +
  //         this.uploadFileType[0] +
  //         ") could not be uploaded.(PDF, JPG, JPEG and PNG files are supported)";
  //     }
  //   }
  // }
  response: any;

  uploadFile(file: any) {
    if (file && file.type) {
      this.uploadFileType[0] = file.type;
      this.apiService.uploadupdatedFile(
        file,
        this.documentTypeId,
        this.universityData.name,
        (resp) => {
          if (resp?.detectedValues) {
            this.IsLoadData = false;
            this.setdetectedValues(resp.detectedValues);
          }

          if (!resp || resp.error) {
            if (!resp || resp.status == 0) {
              this.errorMessage =
                "Something went wrong while uploading award letter. ";
            } else {
              this.errorMessage = resp.message;
            }
          } else {
            this.errorMessage = "";
          }
          this.ocrResponseList[this.index] = resp;
          this.universityVfrFileUpdated = [];
          this.universityVfrFileUpdated.push(resp);
          this.isUploadedFile = true;
          // this.fileUploadArray = [];
          // this.fileUploadArray = resp;
          // console.log(this.fileUploadArray, "fileUploadArray");
          // this.ocrResponseList[this.index] = resp;
          // this.universityVfrFileUpdated = [];
          // this.universityVfrFileUpdated.push(resp);
          // this.isUploadedFile = true;
        }
      );
    }
  }

  changeFileType(type) {
    switch (type) {
      case "PDF":
        this.acceptFileType = "application/pdf";
        break;
      case "IMAGE":
        this.acceptFileType = "image/*";
        break;
      case "JPG":
        this.acceptFileType = "image/jpg,image/jpeg";
        break;
      case "PNG":
        this.acceptFileType = "image/png,image/x-png";
        break;
      case "GIF":
        this.acceptFileType = "image/gif";
        break;
      default:
        this.acceptFileType = "application/pdf,image/*";
        break;
    }
  }

  submitFile() {
    // console.log("File Submit Clicked");
    // this.loadingImage = true;

    if (this.filesArray.length > 0) {
      this.fileIds = [];
      this.fileUploadArray[0].fileIds = [];
      this.fileUploadArray[0].files = Object.assign([], this.filesArray);
      if (
        this.uploadFileType[0] &&
        this.uploadFileType[0].indexOf("pdf") > -1
      ) {
        this.apiService.unmergePDF(this.filesArray[0].resp.id, (resp) => {
          if (resp && resp.length > 0) {
            for (let index = 0; index < resp.length; index++) {
              this.fileIds.push(resp[index].id);
              this.fileUploadArray[0].fileIds.push(resp[index].id);
            }
          }
          // this.checkFileAlreadyUploaded(this.selectedUniversityList[this.selectedUniversityIndex].ipedsId);
          // this.modalRef.hide();
          // this.loadingImage = false;
          this.fileAnalysis();
        });
      } else {
        for (let index = 0; index < this.filesArray.length; index++) {
          this.fileIds.push(this.filesArray[index].resp.id);
          this.fileUploadArray[0].fileIds.push(this.filesArray[index].resp.id);
        }

        // this.checkFileAlreadyUploaded(this.selectedUniversityList[this.selectedUniversityIndex].ipedsId);

        // this.setInterestPageAnswer(
        //   "ul" +
        //     this.selectedUniversityList[this.selectedUniversityIndex].ipedsId,
        //   this.selectedUniversityList[this.selectedUniversityIndex].ipedsId +
        //     "",
        //   [],
        //   "Upload"
        // );
        // this.modalRef.hide();
        // this.loadingImage = false;
        this.fileAnalysis();
      }
    }
    this.filesArray = [];
  }
  // isImage(content: any): boolean {
  //   console.log(content);
  //   if (content.files[0].resp.contentType == "image/png") {
  //     return true;
  //   }
  //   return false;
  // }

  fileAnalysis() {
    this.spinnerService.show();
    this.apiService.resetFileData();
    this.analysFile(0);
  }

  private analysFile(count: number) {
    // this.modalParentRef.hide();
    const element = this.fileUploadArray[count];
    const uniName = this.universityData.name;
    this.apiService.fileAnalysis(
      uniName,
      element.fileIds,
      element,
      count,
      (resp) => {
        this.totalAmount = {
          totalCoa: 0,
          totalGrantsSCholarship: 0,
          totalLoan: 0,
          totalAdditionalost: 0,
          outOfPocket: 0,
          coaCorrect: true,
          grantCorrect: true,
          coaValidated: false,
          grantValidated: false,
        };

        resp.detectedValues.forEach((elem) => {
          if (elem.mapWith == 1) {
            this.totalAmount.totalCoa += Number(elem.value);
          } else if (elem.mapWith == 2) {
            this.totalAmount.totalGrantsSCholarship += Number(elem.value);
          } else if (elem.mapWith == 3) {
            this.totalAmount.totalLoan += Number(elem.value);
          } else if (elem.mapWith == 2) {
            this.totalAmount.totalAdditionalost += Number(elem.value);
          }
        });

        this.totalAmount.outOfPocket =
          this.totalAmount.totalCoa - this.totalAmount.totalGrantsSCholarship >
          0
            ? this.totalAmount.totalCoa -
              this.totalAmount.totalGrantsSCholarship
            : 0;
        // console.log(resp, this.totalAmount);
        // this.IsLoadData = false;
        this.cdref.detectChanges();

        this.fileSubmit[element.universityName] = resp;
        this.ocrResponseList[this.index] = resp;

        this.universityVfrFileUpdated = [];
        this.universityVfrFileUpdated.push(resp);
        this.isUploadedFile = true;

        this.spinnerService.hide();

        count++;
        if (count == this.fileUploadArray.length) {
        } else {
          this.analysFile(count);
        }
      }
    );
  }

  setdetectedValues(resp: any) {
    this.totalAmount = {
      totalCoa: 0,
      totalGrantsSCholarship: 0,
      totalLoan: 0,
      totalAdditionalost: 0,
      outOfPocket: 0,
      coaCorrect: true,
      grantCorrect: true,
      coaValidated: false,
      grantValidated: false,
    };

    resp.forEach((elem) => {
      if (elem.mapWith == 1) {
        this.totalAmount.totalCoa += Number(elem.value);
      } else if (elem.mapWith == 2) {
        this.totalAmount.totalGrantsSCholarship += Number(elem.value);
      } else if (elem.mapWith == 3) {
        this.totalAmount.totalLoan += Number(elem.value);
      } else if (elem.mapWith == 2) {
        this.totalAmount.totalAdditionalost += Number(elem.value);
      }
    });

    this.totalAmount.outOfPocket =
      this.totalAmount.totalCoa - this.totalAmount.totalGrantsSCholarship > 0
        ? this.totalAmount.totalCoa - this.totalAmount.totalGrantsSCholarship
        : 0;
    // console.log(resp, this.totalAmount);
    // this.IsLoadData = false;
    this.cdref.detectChanges();

    var myImg = document.querySelectorAll(".zoom-in-out");
    let newWidth = 0;
    myImg.forEach((image) => {
      const width = image.clientWidth;
      newWidth = width - 100;
      this.zoomInOutClientWith = newWidth;
    });
  }

  analysisFile() {
    this.apiService.resetFileData();
    for (let index = 0; index < this.fileUploadArray.length; index++) {
      this.analysFilewithdocumentTypeId(index, this.documentTypeId);
    }
  }
  private analysFilewithdocumentTypeId(count: number, documentTypeId: string) {
    const element = this.fileUploadArray[count];
    this.apiService.fileAnalysisWithdocumentTypeId(
      documentTypeId,
      element.universityName,
      element.fileIds,
      element,
      count,
      (resp) => {
        this.fileSubmit[element.universityName] = resp;
        count++;
        if (count == this.fileUploadArray.length) {
          this.apiService.ocrSubmitList(this.fileSubmit, () => {});
        } else {
          this.analysFile(count);
        }
      }
    );
  }

  fileSubmit = {};

  getToday(date) {
    var local = new Date(date);
    local.setMinutes(date.getMinutes() - date.getTimezoneOffset());
    return local.toJSON().slice(0, 10);
  }

  changeAnalysis() {
    const element = this.fileUploadArray[0];
    const uniName = this.universityData.name;
    const data = this.universityVfrFileUpdated[0];
    // const data = this.ocrResponseList[this.index];

    const totalCoaIndex = data.detectedValues.findIndex((elem) => {
      return elem.fieldId == 501;
    });

    if (totalCoaIndex != -1) {
      data.detectedValues.splice(totalCoaIndex, 1, {
        fieldId: 501,
        fieldName: " Total COA",
        value: this.totalAmount.totalCoa,
        mapWith: "5",
        confidenceLevel: "MODERATE",
        isManuallyEdited: true,
        editedBy: "TOP5_TOOL",
      });
    } else {
      data.detectedValues.push({
        fieldId: 501,
        fieldName: " Total COA",
        value: this.totalAmount.totalCoa,
        mapWith: "5",
        confidenceLevel: "MODERATE",
        isManuallyEdited: true,
        editedBy: "TOP5_TOOL",
      });
    }
    const totalAidIndex = data.detectedValues.findIndex((elem) => {
      return elem.fieldId == 601;
    });

    if (totalAidIndex != -1) {
      data.detectedValues.splice(totalAidIndex, 1, {
        fieldId: 601,
        fieldName: " Total COA",
        value: this.totalAmount.totalGrantsSCholarship,
        mapWith: "5",
        confidenceLevel: "MODERATE",
        isManuallyEdited: true,
        editedBy: "TOP5_TOOL",
      });
    } else {
      data.detectedValues.push({
        fieldId: 601,
        fieldName: " Total Aid",
        value: this.totalAmount.totalGrantsSCholarship,
        mapWith: "5",
        confidenceLevel: "MODERATE",
        isManuallyEdited: true,
        editedBy: "TOP5_TOOL",
      });
    }

    this.totalAmount.outOfPocket =
      this.totalAmount.totalCoa - this.totalAmount.totalGrantsSCholarship > 0
        ? this.totalAmount.totalCoa - this.totalAmount.totalGrantsSCholarship
        : 0;
    this.apiService.fileAnalysisUpdate(uniName, data, element, 0, (resp) => {
      if (resp) {
        this.fileSubmit[element.universityName] = resp;
        this.ocrResponseList[this.index] = resp;

        this.cdref.detectChanges();
        this.universityVfrFileUpdated = [];
        this.universityVfrFileUpdated.push(resp);
        this.isUploadedFile = true;
        // this.notificatioService.showNotification(
        //   "Scholarship Grant amount updated successfully.",
        //   "Updated",
        //   true,
        //   "success"
        // );
        this.close();
      }
    });
  }
  onImageHover() {
    let classDelete = document.getElementById("myresult");
    classDelete.classList.remove("hide");
  }
  onImageout() {
    let classAdd = document.getElementById("myresult");
    classAdd.classList.add("hide");
  }
  getZoomimgSrc(fileId: string) {
    if (fileId != undefined) {
      return this.getPath() + "fileStorage/download/" + fileId;
      //this.onImageHover();
    }
  }

  zoomin() {
    if (this.FileType?.[1] == "pdf" || this.responsedocumentype == "pdf") {
      this.isZoomOutDisable = true;
      if (this.zoom < 30) {
        this.zoom++;
      } else {
        this.isZoomInDisable = true;
      }
      this.isZoomOutDisable = false;
    }
    // Image part
    else {
      if (this.zoomValue < 1000) {
        this.isZoomOutDisable = false;
        this.zoomValue += 10;
      } else {
        this.isZoomInDisable = true;
      }
    }
  }
  zoomout() {
    if (this.FileType?.[1] == "pdf" || this.responsedocumentype == "pdf") {
      if (this.zoom > 1) {
        this.zoom--;
        this.isZoomInDisable = false;
      } else {
        this.isZoomOutDisable = true;
      }
    }
    // Image part
    else {
      if (this.zoomValue > 10) {
        this.isZoomInDisable = false;
        this.zoomValue -= 10;
      }
      if (this.zoomValue == this.originalZoomValue) {
        this.isZoomOutDisable = true;
      }
    }
  }
  reset() {
    if (this.FileType?.[1] == "pdf" || this.responsedocumentype == "pdf") {
      this.zoom = 1;
      this.isZoomOutDisable = true;
      this.isZoomInDisable = false;
    } else {
      this.isZoomOutDisable = true;
      this.isZoomInDisable = false;
      this.zoomValue = this.originalZoomValue;
    }
  }

  setClientWidth() {
    this.isZoomOutDisable = true;
    this.isZoomInDisable = false;
    var myImg = document.querySelectorAll(".zoom-in-out");
    myImg.forEach((image) => {
      let newWidth = 0;
      const width = image.clientWidth;
      newWidth = width + 100;
      this.zoomInOutClientWith = newWidth + 100;
      this.renderer.setStyle(image, "width", newWidth + 100 + "px");
    });
  }
}
